import { createSelector } from 'reselect';
import { immutableToJS } from '../../devUtils/commonUtils';

const selectIndusindFaqsDomain = (state) => state.get('indusindFaqs');
export const selectIndusindFaqs = () => createSelector(
  selectIndusindFaqsDomain,
  (IndusindFaqs) => IndusindFaqs,
);

export const indusindZingerCardsFaqSuccess = () => createSelector(
  selectIndusindFaqsDomain,
  (IndusindFaqs) => immutableToJS(IndusindFaqs.get('indusindZingerCardsFaq')),
);

export const indusindKuberCardsFaqSuccess = () => createSelector(
  selectIndusindFaqsDomain,
  (IndusindFaqs) => immutableToJS(IndusindFaqs.get('indusindKuberCardsFaq')),
);




// WEBPACK FOOTER //
// client/containers/IndusindZingerCardsFaqs/selectors.js